import { Gene, GeneExpression, GeneType } from "../../../types/Gene"

// ------------------- Interfaces ----------------------------

export type CareEnum = "FEED" | "SUBSTRATE" | "DEFECATION" | "SHED";

export interface TreeIndividual {
    id: number,
    picture: {
        url: string,
        credit: string,
    }
    img: string,
    name: string,
    morph: string,
    breeder: string
    indiv_id?: number,
    placeholder?: boolean,
    family_id: number | null,
    sex: 'male' | 'female' | null,
    genes?: Gene[],
    pictures: CollectionReptilePicture[],
    max_photos: number,
}


export interface FamilyTreeFamily {
    family_id: number,
    individual: TreeIndividual,
    father_family: FamilyTreeFamily | null,
    mother_family: FamilyTreeFamily | null,
}

export interface FamilyTree {
    self: TreeIndividual,
    F: TreeIndividual,
    M: TreeIndividual,
    MM: TreeIndividual,
    MF: TreeIndividual,
    FM: TreeIndividual,
    FF: TreeIndividual,
}


export interface WeightEntry {
    id: number,
    date: string,
    weight: number
}

export interface CollectionReptilePicture {
    id: number,
    url: string,
    credit?: string,
}

export interface CollectionReptileGene {
    id: number, // the id of the joiner table
    gene_id: number, // the id of the gene table
    gene_name: string,
    gene_type: GeneType,
    isHet: boolean,
    expression: GeneExpression,
}

export interface ListingPrice {
    id: number,
    price: number,
    firmPrice: boolean,
    description: string,
}

export interface CollectionCareRecord {
    id: number,
    date: string,
    description: string,
}
export interface CollectionReptileLabel {
    id: number,
    text: string
}

export type CollectionCareRecordType = "shed_dates" | "feed_dates" | "def_dates" | "substrate_dates";

export interface CollectionReptile {
    id: number,
    name: string,
    uuid: string,
    is_species: boolean,
    genes: CollectionReptileGene[],
    display_genes: CollectionReptileGene[],
    morph_name_id: number | null,
    user_id: number,
    user_gid: string,
    hatch_date: string,
    picture?: string,
    pictures: CollectionReptilePicture[],
    hatch?: string,
    reptile: string,
    reptile_name: string,
    listing_price: ListingPrice | null,
    gender: string,
    last_fed: string,
    sold_price?: number,
    feed?: string,
    last_substrate: string,
    substrate?: string,
    last_def: string,
    def?: string,
    last_shed: string,
    shed?: string,
    status: string,
    morph_name: string,
    created_timestamp: string,
    weight: WeightEntry[],
    treeData: FamilyTreeFamily,
    type: string,
    morph: string,
    has_tree: boolean,
    shed_dates: CollectionCareRecord[],
    feed_dates: CollectionCareRecord[],
    def_dates: CollectionCareRecord[],
    substrate_dates: CollectionCareRecord[],
    labels: CollectionReptileLabel[]
}

export interface CollectionReptileGroup {
    id: number,
    reptile_group_id: number,
    morph_name: string,
    savedReptiles?: CollectionReptile[],
    status?: string,
    unsexed: number,
    males: number,
    females: number,
    genes: Gene[]
}

export interface Pairing {
    id: number,
    mother: CollectionReptile | null,
    father: CollectionReptile | null,
    paired_date: string,
    separation_date: string,
    notes: string,
}


// ------------------- Blank Objects ----------------------------


export const blankTreeIndividual = {
    id: -1,
    img: "",
    picture: {
        url: "",
        credit: ""
    },
    name: "",
    morph: "",
    breeder: "",
    pictures: [],
    max_photos: 0,
    genes: [],
    indiv_id: -1,
    family_id: null,
    sex: null,
}

export const blankFamilyTree = {
    self: blankTreeIndividual,
    F: blankTreeIndividual,
    M: blankTreeIndividual,
    MM: blankTreeIndividual,
    MF: blankTreeIndividual,
    FM: blankTreeIndividual,
    FF: blankTreeIndividual,
}

export const blankWeightEntry = {
    id: -1,
    date: new Date().toDateString(),
    weight: 0
}
const blankFamilyTreeFamily: FamilyTreeFamily = {
    family_id: -1,
    individual: blankTreeIndividual,
    father_family: null,
    mother_family: null,
}
export const blankCollectionReptile: CollectionReptile = {
    id: -1,
    name: "",
    hatch_date: "",
    is_species: false,
    genes: [],
    display_genes: [],
    morph_name_id: null,
    reptile: "",
    reptile_name: "",
    picture: "",
    hatch: "",
    gender: "",
    last_fed: "",
    sold_price: -1,
    feed: "",
    last_substrate: "",
    substrate: "",
    last_def: "",
    def: "",
    last_shed: "",
    shed: "",
    status: "",
    morph_name: "",
    created_timestamp: "",
    listing_price: null,
    weight: [blankWeightEntry],
    treeData: blankFamilyTreeFamily,
    type: "local",
    morph: "",
    has_tree: false,
    pictures: [],
    uuid: "",
    user_id: -1,
    user_gid: "",
    shed_dates: [],
    feed_dates: [],
    def_dates: [],
    substrate_dates: [],
}

export const blankPairing: Pairing = {
    id: -1,
    mother: null,
    father: null,
    paired_date: new Date().toDateString(),
    separation_date: new Date().toDateString(),
    notes: "",
}